
<div>
    <div style="display: block;">
      <div style="width: 100%">
        <h1 style="font-size: 1.5rem">Basic Info</h1>
      </div>
    </div>

    <lib-content-loader *ngIf="loading"></lib-content-loader>
    <div *ngIf="!loading" [formGroup]="form" style="margin-top: 1rem">

    <div>
        <mat-form-field actions appearance="outline" >
            <mat-label>First Name</mat-label>
            <input matInput 
            type="text" 
            formControlName="first_name"
            required>
            <mat-error *ngIf="form.get('first_name')?.errors">
                First name is required.
            </mat-error>
        </mat-form-field>
        
    </div>

    <div>
        <mat-form-field actions appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" 
            formControlName="last_name"
            required>
            <mat-error *ngIf="form.get('last_name')?.errors">
               Last name is required.
            </mat-error>
        </mat-form-field>
    </div>

    <div>
        <mat-form-field actions appearance="outline">
            <mat-label>Address Line 1</mat-label>
            <input matInput type="text" 
            formControlName="address1"
            >
        </mat-form-field>
    </div>

    <div>
        <mat-form-field actions appearance="outline">
            <mat-label>Address Line 2</mat-label>
            <input matInput type="text" formControlName="address2">
        </mat-form-field>
    </div>

    <div>
        <mat-form-field actions appearance="outline">
            <mat-label>Postal Code</mat-label>
            <input matInput type="text" formControlName="postal_code">
        </mat-form-field>
    </div>
    <div>
        <mat-form-field actions appearance="outline">
            <mat-label>Workplace</mat-label>
            <input matInput type="text" formControlName="org_name">
        </mat-form-field>
    </div>
    <div>
        <mat-form-field class="email" actions appearance="outline">
            <mat-label>Email</mat-label>
            <input style="color: rgb(107, 107, 114);" matInput formControlName="email" readonly>
        </mat-form-field>
        @if (!person_id) {
            <p>
                To change your email address, contact <a [href]="email_change_link">info&#64;owlhub.com</a>.
            </p>
        }
    </div>

</div>
<div style="padding: 0 4rem 1rem" >
    <lib-button color="primary" style="padding: 5px;" mat-button (click)="router.navigate(['/'])">Back</lib-button>
    <lib-button color="primary" mat-button (click)="update()" [disabled]="!form.valid">Save</lib-button>
</div>
</div>

